import React from 'react';
import PropTypes from 'prop-types';
import CwDropdownItem from './CwDropdownItem';
import css from './CwDropdown.scss';
import scrollIntoView from 'dom-scroll-into-view';

/**
 * Based on react-autocomplete:
 * https://github.com/reactjs/react-autocomplete
 */

class CwDropdown extends React.Component {
  constructor(props) {
    super(props);

    this._mousePosition = { x: 0, y: 0 };
    this._mousedOver = false;
  }

  componentDidUpdate() {
    this.scrollItemIntoView();
  }
  
  scrollItemIntoView() {
    const highlightedItem = this.refs[`item-${this.props.highlightedIndex}`];
    if (highlightedItem) {
      const itemNode = highlightedItem.div;
      const menuNode = this.refs.menu;
      scrollIntoView(
        itemNode,
        menuNode,
        { onlyScrollIfNeeded: true }
      );
    }
  }

  handleItemMouseEnter = (index, enterPosition) => {
    // Don't fire onMouseEnter if mouse didn't actually move (i.e. the dropdown was scrolled by arrow keys)
    if (this.props.onMouseEnter && (this._mousePosition.x !== enterPosition.x || this._mousePosition.y !== enterPosition.y)) {
      this.props.onMouseEnter(index);
    }
  };

  handleItemMouseMove = (position) => {
    this._mousePosition = position;
  }

  handleItemClick = (item) => {
    if (this.props.onClick) {
      this.props.onClick(item);
    }
  };

  handleItemMouseDown = (blur) => {
    if (this.props.onMouseDown) {
      this.props.onMouseDown(blur);
    }
  };

  isMousedOver = () => {
    return this._mousedOver;
  };

  handleDropdownEnter = () => {
    this._mousedOver = true;
  };

  handleDropdownLeave = () => {
    this._mousedOver = false;
  };

  renderItem(item, isHighlighted, index) {

    return (
      <CwDropdownItem
        onFocus={this.props.onFocus}
        onBlur={this.props.onBlur}
        isHighlighted={isHighlighted}
        item={item}
        itemHeight={this.props.itemHeight}
        onClick={this.handleItemClick}
        onMouseEnter={this.handleItemMouseEnter}
        onMouseDown={this.handleItemMouseDown}
        onMouseMove={this.handleItemMouseMove}
        index={index}
        key={index}
        ref={`item-${index}`}
      />
    );
  }

  renderPicker(isHighlighted) {
    return (
      <CwDropdownItem
        isPicker={true}
        isHighlighted={isHighlighted}
        item={{ id: -1, name: this.props.pickerText }}
        onClick={this.handleItemClick}
        onMouseEnter={this.handleItemMouseEnter}
        onMouseDown={this.handleItemMouseDown}
        onMouseMove={this.handleItemMouseMove}
        index={-1}
        key={-1}
        ref={`item-${-1}`}
      />
    );
  }

  render() {

    let picker = this.props.pickerText ? this.renderPicker(this.props.highlightedIndex === -1) : null;

    if (this.props.items.length === 0) {
      return (
        <div data-cwid='dropdown-options' className={css.dropDown} style={this.props.style}
          onMouseOver={this.handleDropdownEnter} onMouseOut={this.handleDropdownLeave}>
          {picker}
        </div>
      );
    }
    else {
      let items = this.props.items.map((item, index) => {
        return this.renderItem(
          item,
          this.props.highlightedIndex === index,
          index,
        );
      });
      return (
        <div data-cwid='dropdown-options' className={css.dropDown} style={this.props.style} ref="menu"
          onMouseOver={this.handleDropdownEnter} onMouseOut={this.handleDropdownLeave}>
          {picker}
          {items}
        </div>
      );
    }
  }
}

CwDropdown.propTypes = {
  /**
   * Array of items to be listed in the dropdown.
   */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
      name: PropTypes.string,
      leftWidget: PropTypes.element
    })
  ),
  /**
   * Index of the currently highlighted item in the dropdown.
   */
  highlightedIndex: PropTypes.number,
  /**
   * Set of style properties to determine the dropdown's size and position. Must contain left, top, and minWidth.
   */
  style: PropTypes.shape({
    left: PropTypes.number,
    top: PropTypes.number,
    minWidth: PropTypes.number
  }),
  /**
   * Callback function that is fired when dropdown item is clicked.
   */
  onClick: PropTypes.func,
  /**
   * Callback function that is fired when dropdown item is hovered over.
   */
  onMouseEnter: PropTypes.func,
  /**
   * Callback function that is fired before onClick. Typically used to ignore blur in order to prevent dropdown from derezzing before a selection is registered.
   */
  onMouseDown: PropTypes.func,
  /**
   * Text to display on combobox picker.
   */
  pickerText: PropTypes.string,
  /**
   * Callback function that is fired when the component is focused.
   */
  onFocus: PropTypes.func,
  /**
   * Callback function that is fired when the component is blurred.
   */
  onBlur: PropTypes.func,
  /**
   * Callback function that is fired when the parent div of dropdown is hovered over.
   */
  onDropdownEnter: PropTypes.func,
  /**
   * Callback function that is fired when the parent div of dropdown is no longer hovered over.
   */
  onDropdownLeave: PropTypes.func,
  /**
   * Used to override height on individual items in the drop down
   */
  itemHeight: PropTypes.number
};

export default CwDropdown;


// WEBPACK FOOTER //
// ./src/components/cwdropdown/CwDropdown.jsx